import { Anskaffningsformer, Atgardstyp, AvverkningsgruppForkortning } from "~app/common/models/constants";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { AtgardPlaneringsstatusService } from "~app/features/planera/services/atgard-planeringsstatus.service";

export class AtgardAddableBehaviour {
    constructor(
        private readonly atgard: IAtgard,
        private readonly arbetsorder: IArbetsorderDetail,
        private readonly atgardPlaneringsstatusService: AtgardPlaneringsstatusService
    ) { }

    isAtgardAddable = (): boolean => {
        const atgard = this.atgard;
        const arbetsorder = this.arbetsorder;
        const atgardPlaneringsstatusService = this.atgardPlaneringsstatusService;

        if (!arbetsorder) {
            return false;
        }

        const anskaffningsformNotVirkeskop = this.arbetsorder.anskaffningsform !== Anskaffningsformer.Virkeskop;
        const isArbetsorderStatusNotTillganglig = atgardPlaneringsstatusService.isNotYetTillgangliga(arbetsorder.atgarder);
        if (anskaffningsformNotVirkeskop && isArbetsorderStatusNotTillganglig) {
            return false;
        }

        if (anskaffningsformNotVirkeskop && atgard && atgardPlaneringsstatusService.isNotYetTillganglig(atgard)) {
            return false;
        }

        if (arbetsorder.isLeveransvirke)  {
            return false;
        }

        const isAtgardAlreadyAdded = arbetsorder.atgarder.some(atg => atg.guid === atgard.guid);
        if (isAtgardAlreadyAdded) {
            return false;
        }

        const isCompatibleArbetsorder = !arbetsorder.atgarder.some(atg => atg.virkeskopskontraktId !== atgard.virkeskopskontraktId);
        if (!isCompatibleArbetsorder) {
            return false;
        }

        return this.checkForCorrectAtgardsGrupperToCombine();
    };

    checkForCorrectAtgardsGrupperToCombine(): boolean {
        // NS-åtgärder får enbart slås ihop med andra NS-åtgärder
        if (this.atgard.atgardstypForkortning === AvverkningsgruppForkortning.NSAvverkning &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstypForkortning !== AvverkningsgruppForkortning.NSAvverkning)) {
            return false;
        }

        if (this.atgard.atgardstypForkortning !== AvverkningsgruppForkortning.NSAvverkning &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstypForkortning === AvverkningsgruppForkortning.NSAvverkning)) {
            return false;
        }

        // Hyggesfria åtgärder
        if (this.atgard.atgardstypForkortning === AvverkningsgruppForkortning.HyggesfriAvverkning &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstypForkortning !== AvverkningsgruppForkortning.HyggesfriAvverkning)) {
            return false;
        }

        if (this.atgard.atgardstypForkortning !== AvverkningsgruppForkortning.HyggesfriAvverkning &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstypForkortning === AvverkningsgruppForkortning.HyggesfriAvverkning)) {
            return false;
        }

        // Grot
        // Ska inte gå att lägga till/flytta tv.
        if (this.atgard.atgardstypForkortning === AvverkningsgruppForkortning.Grot) {
            return false;
        }

        if (this.atgard.atgardstypForkortning !== AvverkningsgruppForkortning.Grot &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstypForkortning === AvverkningsgruppForkortning.Grot)) {
            return false;
        }

        return this.checkForCorrectAtgardstyperToCombine();
    }

    checkForCorrectAtgardstyperToCombine(): boolean {
        // Skada plockhuggning
        if (this.atgard.atgardstyp !== Atgardstyp.SkadaPlockhuggning &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstyp === Atgardstyp.SkadaPlockhuggning)) {
            return false;
        }

        if (this.atgard.atgardstyp === Atgardstyp.SkadaPlockhuggning &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstyp !== Atgardstyp.SkadaPlockhuggning)) {
            return false;
        }

        // Gallring HF
        if (this.atgard.atgardstyp !== Atgardstyp.GallringHF &&
            this.atgard.atgardstypForkortning !== AvverkningsgruppForkortning.Gallring &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstyp === Atgardstyp.GallringHF)) {
            return false;
        }

        if (this.atgard.atgardstyp === Atgardstyp.GallringHF &&
            this.arbetsorder.atgarder.some(atg => atg.atgardstypForkortning !== AvverkningsgruppForkortning.Gallring)) {
            return false;
        }

        return true;
    }
}
